import { Router } from '@angular/router';
import {
  Component,
  OnInit,
  ElementRef,
  AfterViewInit,
  Input,
  OnChanges,
  Output,
  EventEmitter,
  OnDestroy,
  HostListener,
  ViewChild
} from '@angular/core';
import { LoginService } from '../../../services/login.service';
import { PlanMainService } from './../../../plan/service/plan-main.service';
import { PlanService } from './../../../services/plan.service';
import { Subject } from 'rxjs/Subject';
import { Kyotens } from './../../../models/plan/kyotens';
import { saveAs } from 'file-saver';
import { DataService } from '../../../services/data.service';
import { SettingDialogItemVisibleSetting } from '../../../setting-dialog/setting-dialog-item-visible-setting';

export interface Stafflogin {
  staffCd: string;
  pass: string;
}
export interface Staffloginres {
  staffNm: string;
  results: boolean;
}
export interface Staffdropdown {
  staffCd: string;
  staffNm: string;
  kyotenCd: string;
  kyotenNm: string;
}
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnChanges, OnDestroy {
  public salePlanEdit: number = 1;
  public resStatus: number;
  public showStaffLogin: boolean;
  public statusLogin: boolean;
  public staffId: string;
  public staffPass: string;
  public staffName: string;
  public popupState: boolean;
  public msg: string;
  public idstaffRemember: boolean;
  public staffKyoten: Staffdropdown[] = [];
  public staffLogin: any;
  private ngUnsubscribe = new Subject();
  public isOpenBussinessManage = false;
  public isOpenSetting = false;
  public isOpenOsusumeSetting = false;
  public dialogWaiting = '';
  public menuAuthority: any;
  public showDialog: boolean = false;
  public titledialog: string;
  public errMsg: string = '';
  public newInfo = false;
  // public staffKyotenItem: string; // Staffdropdown;

  //▽[2021-09-08 kyuwa #7394]add:新車デリ考慮
  public showGyoumuKanri = false;

  // マスタ画面ボタン表示制御変数
  private masterMenuVisibleSetting:SettingDialogItemVisibleSetting = {
    channelVisible: false,
    gyoushaVisible: false,
    kashuuhiVisible: false,
    nyuukoBunruiVisible: false,
    enqueteVisible: false,
    rankVisible: false,
    tentouKakakuChouseiVisible: false
  };

  //▽[2021-09-08 kyuwa #7394]add:新車デリ考慮
  // 操作マニュアルファイル切替ID
  private manualFileId = null;
  //△[2021-09-08 kyuwa #7394]add:新車デリ考慮

  public kyotenNm: string = '';

  @Input() staffLoginShow: boolean;
  @Input() staffLogout: boolean;
  @Output() staffRes = new EventEmitter<any>();

  public loader = false;
  @ViewChild('btnManual') btnManual: ElementRef;
  @ViewChild('btnSetting') btnSetting: ElementRef;
  public isBtnBussiness = false;
  public isBtnSetting = false;

  shaten: string = '';
  constructor(
    private loginService: LoginService,
    private router: Router,
    private planmainService: PlanMainService,
    private planService: PlanService,
    private element: ElementRef,
    private _data: DataService
  ) {
    this.showStaffLogin = false;
    this.statusLogin = false;
    this.popupState = true;
    this.idstaffRemember = false;
  }

  @HostListener('document:click', ['$event'])
  handleClick(event: Event) {
    this.isBtnBussiness = this.btnManual.nativeElement.contains(event.target);
    this.isBtnSetting = this.btnSetting.nativeElement.contains(event.target);
  }

  async ngOnInit() {        //[2021-09-08 kyuwa #7394]upd:新車デリ考慮
    this.checkStafflogin();
    this.authCheck();
    this.getAuthDetail();

    //▽[2021-09-08 kyuwa #7394]add:新車デリ考慮
    let isNcDeli = this.planService._isNewCarDeliveryUser;
    if (isNcDeli == null) {
      // 保持されていなければ、情報を得て保持する
      isNcDeli = await this.planService.isNewCarDeliveryUser();
      this.planService._isNewCarDeliveryUser = isNcDeli;
    }
    this.updateFormSetting(isNcDeli);
    //△[2021-09-08 kyuwa #7394]add:新車デリ考慮

    // this.planService.chosenKyoten
    //   .takeUntil(this.ngUnsubscribe)
    //   .subscribe((sub: Kyotens) => {
    //     this.kyotenNm = sub.kyotenNm;
    //   });
  }

  authCheck() {
    // const staff = this._data.staffData;
    this.planmainService.staffDialog
      .takeUntil(this.ngUnsubscribe)
      .subscribe(e => {
        if (e) {
          // console.log('authCheck()', this.showStaffLogin);
          this.setPageLogin(false);
          this.showStaffLogin = e;
        }
      });

    this.loginService.isLogout
      .takeUntil(this.ngUnsubscribe)
      .subscribe(e => {
        if (e && !this.statusLogin && !this.showStaffLogin) {
          // console.log('​authCheckOut -> ', e);
          this.secondLogout();
        }
      });
    this.planmainService.menuAuthoCallback
      .takeUntil(this.ngUnsubscribe)
      .subscribe(e => {
        if (e) {
          this.menuAutho();
        }
      });
  }

  // 社店側のログアウトボタンイベント
  logout() {
    //▽[2021-09-08 kyuwa #7394]add:新車デリ考慮
    // 保持された新車デリバリー契約状態をクリア
    this.planService._isNewCarDeliveryUser = null;
    //△[2021-09-08 kyuwa #7394]add:新車デリ考慮

    this.loginService
      .checkLogout()
      .takeUntil(this.ngUnsubscribe)
      .subscribe();
    // location.reload();
    setTimeout(() => {
      this.statusLogin = false;
      this.router.navigate(['login']);
    }, 700);
  }

  // 担当者ログアウトのクリックイベント
  secondLogout() {
    this.planmainService.menuAuthoCallback.next(null);
    this.planmainService.getAuthDetail().take(1).subscribe(async res => {   //[2021-09-08 kyuwa #7394]upd:新車デリ考慮
      if (res && res.kyotenCd && res.kyotenNm && res.staffCd && res.staffNm) {
        this.planmainService.loginDialogModel().subscribe();
        setTimeout(() => {
          this.loginService.clearDataAndNavigateToLoginStaff();
        }, 1000);
        this.statusLogin = false;
        this.showStaffLogin = false;
        this._data.clearStaffData();
      } else if (res && res.shatenNm) {
        this._data.shatenNm = res.shatenNm;
      }
      // console.log('​HeaderComponent loginDialogModel() -> ', res);
      // const Remember = this._data.getData('idstaffRemember');
      this.planmainService.onremoveServiceplan();
      // if (this.router.url === '/planmain') {
      //   this.router.navigate(['/home']);
      // }
      // if (!Remember) {
      //   localStorage.removeItem('staffId');
      // }
      // localStorage.removeItem('staffData');
      // localStorage.removeItem('staffCd');
      this.staffName = '';
      this.statusLogin = false;
      // this.showStaffLogin = false;
      this.isOpenBussinessManage = false;
      this.isOpenSetting = false;
      this.loginService.isLogout.next(false);
      this._data.kyotenCdUpdate.next(true);

      //▽[2021-09-08 kyuwa #7394]add:新車デリ考慮
      // 新車デリバリーフラグを再読込し、表示設定を更新する
      const isNewCarDeliveryUser = await this.planService.isNewCarDeliveryUser();
      this.updateFormSetting(isNewCarDeliveryUser);
      //△[2021-09-08 kyuwa #7394]add:新車デリ考慮

    });
  }

  // 担当者ログイン画面でログインが行われた後の処理
  async onClosestafflogin(e) {
    this.showStaffLogin = !e.results;
    this.statusLogin = e.results;
    this.staffRes.emit(this.showStaffLogin);
    this.planmainService.staffDialog.next(null);
    this.kyotenNm = e.kyotenNm;
    this.staffName = e.staffName;

    // this.checkStafflogin();
    this.menuAutho();
    this.checkStafflogin();

    //▽[2021-09-08 kyuwa #7394]add:新車デリ考慮
    // 新車デリバリーフラグを再読込し、表示設定を更新する
    const isNewCarDeliveryUser = await this.planService.isNewCarDeliveryUser();
    this.updateFormSetting(isNewCarDeliveryUser);
    //△[2021-09-08 kyuwa #7394]add:新車デリ考慮

    // this.planmainService.staffDialogCallback.next(true);
    // const routeUrl = this.router.url.split('/');
    // if (routeUrl[1] !== 'home' && routeUrl[1] !== 'newcar' && routeUrl[1] !== 'fukusha') {
    //   console.log('routeUrl', routeUrl);
    //   this.menuAutho();
    // } else if (routeUrl[2] === 'detail') {
    //   this.menuAutho();
    // }
  }

  setPageLogin(isClick) {
    const url = this.router.url.toLowerCase();
    if (url.indexOf('newcar') > -1 || url.indexOf('grade') > -1 || url.indexOf('compare') > -1) {
      this.planmainService.isPageLogin.next('newcar');
    } else if (url.indexOf('usedcar/detail') > -1) {
      this.planmainService.isPageLogin.next('usedcar');
    } else if (isClick) {
      this.planmainService.isPageLogin.next('header');
    }
  }
  clickBtnStaffLogin() {
    // this.planmainService.staffDialogCallback.next(null);
    this.setPageLogin(true);
    if (this.showStaffLogin === true) {
      // if open then close
      this.showStaffLogin = false;
      this.staffRes.emit(false);
    } else if (this.showStaffLogin === false) {
      // if close then open
      this.showStaffLogin = true;
      this.isOpenBussinessManage = false;
      this.isOpenSetting = false;
    }
  }

  ngOnChanges() {
    this.showStaffLogin = this.staffLoginShow;
    // console.log('staffLogout', this.staffLogout);
    // if (!this.staffLogout) {
    //   this.secondLogout();
    // }
  }

  checkStafflogin() {
    const staffData = this._data.staffData;
    this.loginService.isStaffAuthenticated('header')
      .subscribe((data: any) => {
        if (data && data.shatenNm) {
          this.shaten = data.shatenNm;
        }
      });
    if (staffData) {
      this.staffName = staffData.staffNm;
      this.statusLogin = staffData.results;

      if (this.dialogWaiting === 'business') {
        this.isOpenBussinessManage = true;
        // this.dialogWaiting = '';
      } else if (this.dialogWaiting === 'setting') {
        this.isOpenSetting = true;
        // this.dialogWaiting = '';
      }
      this.dialogWaiting = '';
    }
  }

  menuAutho() {
    // console.log('menuAutho()');
    this.planmainService.menuAutho.takeUntil(this.ngUnsubscribe)
      .subscribe(res => {
        if (res) {
          this.menuAuthority = res;
          this.checkAuthority();
        } else {
          if (this._data.staffData) {
            this.planmainService.getMenuAuthority().subscribe((res: any) => {
              if (res) {
                this.menuAuthority = res;
                this.planmainService.setMenuAutho(this.menuAuthority);
                if (res.status === 204) {
                  this.errMsg = '担当者ログインが行われていません。';
                  this.showDialog = true;
                } else {
                  // this.planmainService.staffDialogCallback.next(true);
                  this.showDialog = false;
                }
                // this.planmainService.staffDialogCallback.next(true);
                // this.planmainService.menuAuthoCallback.next(true);

                this.checkAuthority();
              }
            },
              err => {
                this.errMsg = 'システムエラーが発生しました。';
                this.showDialog = true;
              });
          }
        }
      });
  }

  checkAuthority() {
    const routeUrl = this.router.url.split('/');
    if (routeUrl[2] === 'detail' || routeUrl[2] === 'compare') {
      if (this.menuAuthority[4] && this.menuAuthority[4].enabled !== 1) {
        this.salePlanEdit = 0;
        this.planmainService.setSaleEdit.next(this.salePlanEdit);
        this.errMsg = '権限がありません。';
        this.showDialog = true;
      } else {
        this.salePlanEdit = 1;
        this.planmainService.setSaleEdit.next(this.salePlanEdit);
      }
    }
  }

  ToggleBusinessManage() {
    if (this.statusLogin) {
      if (this.showDialog === false) {
        this.isOpenBussinessManage = !this.isOpenBussinessManage;
        this.showStaffLogin = false;
        this.isOpenSetting = false;
      } else {
        this.isOpenBussinessManage = false;
      }
      this.menuAutho();
    } else {
      this.showStaffLogin = true;
      this.dialogWaiting = 'business';
    }
  }

  ToggleSetting() {
    if (this.statusLogin) {
      this.menuAutho();
      if (this.showDialog === false) {
        this.isOpenSetting = !this.isOpenSetting;
        this.showStaffLogin = false;
        this.isOpenBussinessManage = false;
      } else {
        this.isOpenSetting = false;
      }
    } else {
      this.showStaffLogin = true;
      this.dialogWaiting = 'setting';
    }
  }

  getAuthDetail() {
    const staffData = this._data.staffData;
    if (staffData) {
      this.kyotenNm = staffData.kyotenNm;
    } else {
      this.kyotenNm = '';
    }
    // this.planmainService.getAuthDetail().subscribe(res => {
    //   if (res.shatenNm) this.shatenNm = res.shatenNm;
    //   if (res.kyotenNm) this.kyotenNm = res.kyotenNm;
    // });
  }

  businessClose() {
    this.isOpenBussinessManage = false;
  }

  settingClose() {
    this.isOpenSetting = false;
    console.log('cccccc');

  }

  linkToSupport() {
    const windowRef = window.open('https://www.vertice.jp/sys/spt2/',
      'support',
      'resizable, scrollbars, status, width=910, height=900'
    );
  }

  // マニュアルボタン押下時
  downloadManual() {
    this.loader = true;

    //▽[2021-09-08 kyuwa #7394]add:新車デリ考慮
    if (this.manualFileId == null) {
      alert("マニュアルファイルIDが不正です");
      return;
    }
    //△[2021-09-08 kyuwa #7394]add:新車デリ考慮

    this.planmainService.downloadManual(this.manualFileId)  //[2021-09-08 kyuwa #7394]upd:新車デリ考慮
      .subscribe(res => {
        if (res) {
          const blob = new Blob([res], { type: 'application/pdf' });
          saveAs(blob, 'manual.pdf');
        }
        setTimeout(() => {
          this.loader = false;
        }, 500);
      }, err => {
        this.loader = false;
        console.error('download manual fail');
      });
  }

  get isOsusume() {
    return this.planmainService.isOsusume;
  }

  get isEditOsusume() {
    return this._data.getData('osusumeNo');
  }

  clickOutBussiness() {
    if (!this.isBtnBussiness && this.isOpenBussinessManage) {
      this.isOpenBussinessManage = false;
    }
  }

  clickOutSetting() {
    if (!this.isBtnSetting && this.isOpenSetting) {
      this.isOpenSetting = false;
    }
  }

  toggleOsusumeSetting(event) {
    this.isOpenOsusumeSetting = event;
    if (this.isOpenSetting) {
      this.isOpenSetting = false;
    }
  }

  get shatenNm() {
    return this._data.shatenNm || this.shaten;
  }

  onCloseMessage(e) {
    if (this.errMsg === '権限がありません。') {
      this.showDialog = false;
    } else {
      this.showDialog = false;
      this.secondLogout();
      this.showStaffLogin = true;
    }
  }

  get mitsumoriDeleted() {
    return this.planmainService.planType.mitsumoriDeleted;
  }

  get chumonCancel() {
    return this.planmainService.planType.chumonCancel;
  }

  onShowNewInfo(e: boolean) {
    this.newInfo = e;
    console.log('ma nee');

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.getAuthDetail();
  }

  //▽[2021-09-08 kyuwa #7394]add:新車デリ考慮
  /**
   * 表示設定の更新
   */
   updateFormSetting(isNewCarDeliveryUser:boolean) {
    // 新車デリバリーの場合は業務管理を隠す
    this.showGyoumuKanri = !isNewCarDeliveryUser;

    // マスタ画面項目の表示制御
    this.updateMasterItemVisibleSetting(isNewCarDeliveryUser);

    // マニュアルファイル名切替
    let manualId = (isNewCarDeliveryUser ? "manual_ncd" : "manual");
    this.manualFileId = manualId;
  }
  //△[2021-09-08 kyuwa #7394]add:新車デリ考慮

  //▽[2021-09-08 kyuwa #7394]add:新車デリ考慮
  /**
   * マスタ画面項目の表示制御
   * (ここを通すこと)
   */
  updateMasterItemVisibleSetting(isNewCarDeliveryUser:boolean) {
    let visible = !isNewCarDeliveryUser;

    this.masterMenuVisibleSetting = {
      channelVisible: visible,
      gyoushaVisible: visible,
      kashuuhiVisible: visible,
      nyuukoBunruiVisible: visible,
      enqueteVisible: visible,
      rankVisible: visible,
      tentouKakakuChouseiVisible:visible
    };
  }
  //△[2021-09-08 kyuwa #7394]add:新車デリ考慮

}



// WEBPACK FOOTER //
// ./src/app/shared/components/header/header.component.ts